import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@legalis/i18n/en.json';
import es from '@legalis/i18n/es.json';
import nl from '@legalis/i18n/nl.json';
import de from '@legalis/i18n/de.json';
import fr from '@legalis/i18n/fr.json';
i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        es: { translation: es },
        nl: { translation: nl },
        de: { translation: de },
        fr: { translation: fr },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});
export default i18n;
//# sourceMappingURL=config.js.map